import isArrayHasItems from "./isArrayHasItems";

const withArrayValidation = <T, R>(array: T[], fn: (array: T[]) => R[]): R[] =>
  isArrayHasItems(array) ? fn(array) : [];

export default withArrayValidation;
